import { AssetList } from "../trading/AssetList";
import { EarningsMonitor } from "../trading/EarningsMonitor";
import { MetricsGrid } from "../trading/MetricsGrid";
import { OrderHistory } from "../trading/OrderHistory";
import { OrderTicket } from "../trading/OrderTicket";
import { PriceChart } from "../trading/PriceChart";
import { TradingAnalysisMonitor } from "../trading/TradingAnalysisMonitor";
import { Watchlist } from "../trading/Watchlist";

export function TraderPage({ dashboard, selectedSymbol, setSelectedSymbol, selectedTicker, risk, orderTools }) {
  return (
    <main className="terminal-shell" data-testid="trader-page">
      <section className="grid-layout trader-grid">
        <Watchlist tickers={dashboard.tickers} selectedSymbol={selectedSymbol} onSelect={setSelectedSymbol} />
        <section className="main-stack">
          <MetricsGrid portfolio={dashboard.portfolio} risk={risk} />
          <PriceChart bot={dashboard.bot} performance={dashboard.performance} selectedSymbol={selectedSymbol} />
        </section>
      </section>
      <section className="bottom-grid">
        <OrderTicket mode="paper" selectedTicker={selectedTicker} {...orderTools} />
        <AssetList assets={dashboard.portfolio.assets} />
        <OrderHistory trades={dashboard.recent_orders} />
      </section>
      <section className="single-grid"><EarningsMonitor earnings={dashboard.earnings} /></section>
      <section className="single-grid"><TradingAnalysisMonitor analysis={dashboard.trading_analysis} /></section>
    </main>
  );
}